import React from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { mdiDownload } from "@mdi/js";

import fieldRest from "../../../rest/fieldRest";

import { DropdownCaret, Option } from "../../components/DropdownCaret";

const LeftCellStyle = styled.td`
    text-align: left;
`;

const MenuCellStyle = styled.td`
    >div {
        margin-top: -3px;
        margin-bottom: -10px;
    }
`;

export const AntennaItem = ({ antenna }) => {

    const onDownload = async antennaId => {
        await fieldRest.downloadFieldsByAntennaId(antennaId);
    };

    const decodeOriginType = originType => {
        if (originType === "V") {
            return "V";
        } else if (["P", "S", "T"].includes(originType)) {
            return "N";
        }
        return "F";
    };

    const truncateMapping = mapping => {
        if (!mapping) {
            return "";
        }

        return mapping.length > 40 ? `${mapping.substring(0, 40)}...` : mapping;
    };

    return (
        <tr>
            <MenuCellStyle>
                <DropdownCaret>
                    <Option svgIcon={mdiDownload}
                        onClick={() => onDownload(antenna.id)}>
                        {intl.get("common.download")}
                    </Option>
                </DropdownCaret>
            </MenuCellStyle>
            <LeftCellStyle>{antenna.manufacturer}</LeftCellStyle>
            <LeftCellStyle>{antenna.name}</LeftCellStyle>
            <LeftCellStyle>{decodeOriginType(antenna.originType)}</LeftCellStyle>
            <LeftCellStyle>{truncateMapping(antenna.mapping)}</LeftCellStyle>
        </tr>
    );
};